"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sim__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1cded60b-f8ca-42c5-825a-9d8ec6379973"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "436045b2-eab1-47d3-bb53-19827f913c5e",
    "data-name": "Sim_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,16H64A16,16,0,0,0,48,32V160a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,174h64a16,16,0,0,0,16-16v2a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16v-2A16,16,0,0,0,64,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    id: "33c5623a-4a68-4c93-9d7d-3d7fed5fcc16",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,51a10,10,0,1,0,10,10A10,10,0,0,0,96,51Zm4.89,12.69a5.24,5.24,0,0,1-1.43,1.74,5.4,5.4,0,0,1-3.4,1.15l-.57,0a5.4,5.4,0,0,1-.86-.18A5.71,5.71,0,0,1,91.44,64a6.1,6.1,0,0,1-.73-1.61l0-.13a6.62,6.62,0,0,1-.18-1,7,7,0,0,1,0-1v-.1a7.88,7.88,0,0,1,.22-1.44,8.67,8.67,0,0,1,2.81-4.48,9.37,9.37,0,0,1,2.74-1.61c.28-.11.55-.2.82-.28l.51-.14a10.13,10.13,0,0,1,1.27-.23,5.09,5.09,0,0,1,1.26,0l.2,0A4.12,4.12,0,0,0,97,56s0,.09,0,.13a6.58,6.58,0,0,1,2.11.81,4.77,4.77,0,0,1,1.39,1.28l.08.12a4.73,4.73,0,0,1,.6,1.28,5.73,5.73,0,0,1,.23,1.45c0,.07,0,.13,0,.2A5.36,5.36,0,0,1,100.89,63.69Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1cded60b-f8ca-42c5-825a-9d8ec6379973)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 118,
    width: 22,
    height: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 118.5 81 114.38 81 96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 133.38 81 137.5 81 155.88",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 118.5 111 114.38 111 96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 133.38 111 137.5 111 155.88",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "85.63 126 77.13 126 64.13 113",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,138.87",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.13,126",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "106.5 126 115 126 128 113",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,138.87",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,126",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 133.63,
    x2: 96,
    y2: 155.88,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 96.12,
    x2: 96,
    y2: 118.38,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#f4f4f4",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 96,
    width: 60,
    height: 60,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "sim-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "7e38551e-b3df-455c-aec6-14cb0db6d05d",
    "data-name": "Sim_Card_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "1d004863-6ab6-4c44-a418-4c308d84f98f",
    "data-name": "Sim_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#436045b2-eab1-47d3-bb53-19827f913c5e"
  })));
}

var _default = ic_sim__dark;
exports.default = _default;